import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/axios.js';
import { toast } from 'react-toastify';


export const addKeyword = createAsyncThunk('addKeyword', async ({ keyword, projectId }, { rejectWithValue }) => {
    try {
        const res = await api.post('/api/addKeyword', { ...keyword, projectId })
        return res.data;
    } catch (error) {
        return rejectWithValue(err.response?.data || err.message);
    }

});

export const fetchKeywords = createAsyncThunk('fetchKeywords', async (projectId, { rejectWithValue }) => {
    try {
        const res = await api.get('/api/keywords', { params: { projectId } });
        return res.data;
    } catch (error) {
        return rejectWithValue(err.response?.data || err.message);
    }
});


export const deleteKeywords = createAsyncThunk('deleteKeywords', async ({ id, projectId }, { rejectWithValue }) => {
    try {
        const res = await api.delete(`/api/deleteKeyword/${id}`, { params: { projectId } });
        return res.data;
    } catch (error) {
        toast.error('Failed to delete')
        return rejectWithValue(err.response?.data || err.message);
    }
});
export const updateKeyword = createAsyncThunk('updateKeyword', async ({ id, updatedKeyword, projectId }, { rejectWithValue }) => {
    try {
        
        const res = await api.put(`/api/updateKeyword/${id}`, { ...updatedKeyword, projectId });
        return res.data;
    } catch (error) {
        toast.error('Failed to update');
        return rejectWithValue(error.response?.data || error.message);
    }
}
);